import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
// Third party packages
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import * as FileSaver from "file-saver";
import moment from "moment";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { take } from "rxjs/operators";
// Custom packages
import { formatDate } from "@angular/common";
import { AuthService } from "src/app/modules/auth/auth.service";
import { CompaniesService } from "src/app/modules/companies/companies.service";
import { CancelContractDialogComponent } from "src/app/modules/properties/components/cancel-contract-dialog/cancel-contract-dialog.component";
import { PropertyExpireContractItemDialogComponent } from "src/app/modules/properties/components/contract-expire-item-dialog/contract-expire-item-dialog.component";
import { PropertyDeleteDocumentItemDialogComponent } from "src/app/modules/properties/components/document-delete-item-dialog/document-delete-item-dialog.component";
import { ExportContractsDialogComponent } from 'src/app/modules/properties/components/export-contracts-dialog/export-contracts-dialog.component';
import { ExportRasDocsDialogComponent } from 'src/app/modules/properties/components/export-ras-docs-dialog/export-ras-docs-dialog.component';
import { CondoStructuresService } from "src/app/modules/properties/condo-structures.service";
import { DocumentArchivesService } from "src/app/modules/properties/document-archives.service";
import { SettingsService } from "src/app/modules/settings/settings.service";
import { SuppliersService } from "src/app/modules/suppliers/suppliers.service";
import { ConfirmDialogComponent } from "src/app/shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import { Company } from "src/app/shared/models/company/company.model";
import { User } from "src/app/shared/models/user/user.model";
import { ApiService } from "src/app/shared/services/api.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
import { ThemeService } from "src/app/shared/services/theme.service";
import { DocumentDownloadDialogComponent } from "../../../components/document-download-dialog/document-download-dialog.component";
import { PropertyDetailDocumentItemDialogComponent } from "../../../components/document-item-dialog/document-item-dialog.component";
import { PropertyDetailDocumentItemPrintDialogComponent } from "../../../components/document-item-print-dialog/document-item-print-dialog.component";
import { SendEmailDialogComponent } from "../../../components/send-email-dialog/send-email-dialog.component";
import DocumentTypeStructure from "../../../documentTypes";
import { PropertiesService } from "../../../properties.service";
var SearchDocumentsComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function SearchDocumentsComponent(dialog, confirmDialog, newMessageDialog, configService, themeService, cookieService, toastrService, translateService, authService, helperService, documentArchivesService, condoStructuresService, propertiesService, activatedRoute, router, companiesService, suppliersService, settingsService, apiService, // DO NOT MOVE since it's used for 'autocomplete' field type,
    cancelContractDialog) {
        this.dialog = dialog;
        this.confirmDialog = confirmDialog;
        this.newMessageDialog = newMessageDialog;
        this.configService = configService;
        this.themeService = themeService;
        this.cookieService = cookieService;
        this.toastrService = toastrService;
        this.translateService = translateService;
        this.authService = authService;
        this.helperService = helperService;
        this.documentArchivesService = documentArchivesService;
        this.condoStructuresService = condoStructuresService;
        this.propertiesService = propertiesService;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.companiesService = companiesService;
        this.suppliersService = suppliersService;
        this.settingsService = settingsService;
        this.apiService = apiService;
        this.cancelContractDialog = cancelContractDialog;
        this.subscriptions = [];
        this.loggedUser = new User();
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        // BEGIN - Add subUser form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.send"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-paper-plane",
                inline: true,
            },
        };
        this.attachmentBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.attach"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "accent",
            spinnerColor: "accent",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-paperclip",
                inline: true,
            },
        };
        // END - Add communication form
        this.loggedUserRoleType = "";
        this.previousSearchValue = {};
        this.documentArchiveIsLoading = true;
        this.searchIsLoading = false;
        this.allDocs = [];
        this.displayedDocs = [];
        this.documentTypeStructure = new DocumentTypeStructure();
        this.areas = this.configService.availableDocumentAreas;
        this.arguments = [];
        this.argsArray = [];
        this.categoriesArray = [];
        this.displayResults = false;
        this.company = new Company();
        this.selectedDocs = [];
        this.insertedDocs = [];
        this.loggedUserShared = false;
        this.loggedUserTemporary = false;
        this.loggedUserMaster = false;
        this.loggedUserAdmin = false;
        this.showEmailBtn = false;
        this.subscriptionType = "FREE";
        this.companyData = {};
        // Dati aggiuntivi elenco/nuovo elemento
        this.suppliersName = [];
        this.yearsOfStorage = [];
        this.conductorName = [];
        this.nameInterventionArchiving = [];
        this.totMandatoryDocs = 0;
        this.totInsertDocs = 0;
        this.totNotInsertDocs = 0;
        this.totOptionalDocs = 0;
        this.totDocs = 0;
        this.progressBarVal = 0;
        this.progressBarValStyle = { 'width': '0px' };
        this.documentTemplateId = "";
        this.documentTemplate = [];
        this.mappaturaOpen = false;
        this.supplierId = "";
        this.dateFrom = "";
        this.dateTo = "";
        this.protocol = "";
        this.keyword = "";
        this.previousSupplierId = "";
        this.previousDateFrom = "";
        this.previousDateTo = "";
        this.previousProtocol = "";
        this.previousKeyword = "";
        this.masterAndSubscriptionPrivacy = false;
        this.originalOrder = function (a, b) {
            return 0;
        };
    }
    /**
     * Init component
     *
     */
    SearchDocumentsComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Set page title
        this.themeService.setPageTitle(this.translateService.instant("properties.searchPage.pageTitle"));
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) {
            return _this.loggedUser.setData(res);
        }));
        this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(function (res) { return (_this.loggedUserPermissions = res); }));
        // Get logged user's role data
        this.currentRole = this.loggedUser.get("userRoles").find(function (obj) {
            return (obj._id.toString() ===
                _this.authService.loggedUserRequestedRole$.getValue().toString());
        });
        this.loggedUserRole = this.currentRole.role;
        this.loggedUserRoleType = this.currentRole.role.type;
        if (this.currentRole.role.type === "shared") {
            this.loggedUserShared = true;
        }
        if (this.currentRole.role.type === "temporary") {
            this.loggedUserTemporary = true;
        }
        if (this.currentRole.role.type === "master" ||
            this.currentRole.role.type === "collaborator") {
            this.loggedUserMaster = true;
            if (this.currentRole.company._id !== "") {
                this.subscriptions.push(this.companiesService
                    .get(this.currentRole.company._id)
                    .subscribe(function (res) {
                    if (res.status) {
                        _this.companyData = res.data;
                    }
                }));
            }
        }
        this.loggedUserAdmin =
            this.loggedUserRole.type === "admin" ||
                this.loggedUserRole.type === "operator";
        // Get current lang
        this.lang =
            this.cookieService.get("lang") || this.configService.defaultLang;
        // Get property data
        this.propertyId = this.activatedRoute.snapshot.params.propertyId;
        this.subscriptions.push(this.propertiesService.get(this.propertyId).subscribe(function (res) {
            if (res.status && res.data) {
                _this.propertyData = res.data;
                // Set property data
                _this.propertyName = res.data.name;
                _this.structureId = res.data.structure;
                _this.documentArchiveId = res.data.documentArchive;
                if (_this.propertyData &&
                    _this.propertyData.subscription &&
                    _this.propertyData.subscription.key) {
                    _this.subscriptionType = _this.propertyData.subscription.key;
                    if (_this.subscriptionType === 'PRIVACY' && _this.loggedUserMaster) {
                        _this.masterAndSubscriptionPrivacy = true;
                    }
                }
                if (_this.propertyData.admin &&
                    _this.propertyData.admin.company &&
                    _this.propertyData.admin.company._id) {
                    _this.subscriptions.push(_this.companiesService
                        .get(_this.propertyData.admin.company._id)
                        .subscribe(function (res) {
                        if (res.status) {
                            _this.company.setData(res.data);
                        }
                    }));
                }
                // Get form initial values and init the form
                if (_this.structureId) {
                    _this.subscriptions.push(_this.condoStructuresService.get(_this.structureId)
                        .subscribe(function (res) {
                        if (res.status &&
                            res.data) {
                            _this.mappaturaOpen = res.data.open;
                        }
                    }, function (err) {
                        _this.helperService.handleError(err);
                    }));
                    _this.subscriptions.push(_this.settingsService.getDocument().subscribe(function (res) {
                        if (res.status) {
                            if (res.data &&
                                Array.isArray(res.data) &&
                                res.data.length > 0 &&
                                res.data[0].area &&
                                Array.isArray(res.data[0].area)) {
                                _this.documentTemplateId = res.data[0]._id;
                                _this.documentTemplate = res.data[0].area;
                                _this.getStructureData(_this.structureId);
                            }
                        }
                    }, function (err) {
                        //
                    }));
                }
                return;
            }
            // Something bad happened
            // redirect user to home
            _this.router.navigate([_this.lang, "app", "properties", "list"]);
        }, function (err) {
            // if we came here users with given userId do not exist
            _this.router.navigate([_this.lang, "errors", "404"]);
        }));
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.initForm = function () {
        var _this = this;
        if (!this.areas) {
            this.toastrService.error("no areas");
            return;
        }
        // Set fields
        this.fields = [
            {
                fieldGroupClassName: "row",
                hooks: {
                    onInit: function (fieldConfig) {
                        _this.initValues(fieldConfig);
                    },
                },
                fieldGroup: [
                    {
                        className: "col-6",
                        type: "input",
                        key: "docSearch",
                        templateOptions: {
                            label: this.translateService.instant("common.words.search"),
                            placeholder: this.translateService.instant("properties.documents.fields.searchDocument"),
                            required: false,
                        },
                        expressionProperties: {
                            "templateOptions.onChange": function (value) {
                                if (value.docSearch !== _this.previousSearchValue) {
                                    _this.previousSearchValue = value.docSearch;
                                    _this.docSearchChanged(value ? value.docSearch : undefined);
                                }
                            },
                        },
                    },
                    {
                        className: "col-6",
                        type: "autocomplete-supplier",
                        key: "supplier",
                        templateOptions: {
                            customLabel: this.translateService.instant("properties.documents.searchDocs.supplier"),
                            placeholder: this.translateService.instant("properties.documents.searchDocs.searchSupplier"),
                            bindLabel: "companyName",
                            bindValue: "_id",
                            search$: this.suppliersService.getListV2.bind(this),
                            typeToSearchText: this.translateService.instant("common.words.typeToSearch", { minTermLength: 1 }),
                            clearAllText: this.translateService.instant("common.words.clearAll"),
                            notFoundText: this.translateService.instant("common.words.notFound"),
                            loadingText: this.translateService.instant("common.words.loading"),
                        },
                        expressionProperties: {
                            "templateOptions.onChange": function (model) {
                                _this.supplierId = model.supplier && model.supplier !== "" ? model.supplier : "";
                                if (_this.previousSupplierId !== _this.supplierId) {
                                    _this.previousSupplierId = _this.supplierId;
                                    _this.docSearchChanged(_this.previousSearchValue ? _this.previousSearchValue : undefined);
                                }
                            },
                        },
                    },
                    {
                        className: "col-3",
                        type: "datepicker",
                        key: "dateFrom",
                        templateOptions: {
                            label: this.translateService.instant("properties.documents.fields.dateFrom"),
                            placeholder: this.translateService.instant("properties.documents.fields.dateFrom"),
                            required: false,
                        },
                        expressionProperties: {
                            "templateOptions.onChange": function (model) {
                                _this.dateFrom = model.dateFrom && model.dateFrom !== "" ? model.dateFrom : "";
                                if (_this.previousDateFrom !== _this.dateFrom) {
                                    _this.previousDateFrom = _this.dateFrom;
                                    _this.docSearchChanged(_this.previousSearchValue ? _this.previousSearchValue : undefined);
                                }
                            },
                        },
                    },
                    {
                        className: "col-3",
                        type: "datepicker",
                        key: "dateTo",
                        templateOptions: {
                            label: this.translateService.instant("properties.documents.fields.dateTo"),
                            placeholder: this.translateService.instant("properties.documents.fields.dateTo"),
                            required: false,
                        },
                        expressionProperties: {
                            "templateOptions.onChange": function (model) {
                                _this.dateTo = model.dateTo && model.dateTo !== "" ? model.dateTo : "";
                                if (_this.previousDateTo !== _this.dateTo) {
                                    _this.previousDateTo = _this.dateTo;
                                    _this.docSearchChanged(_this.previousSearchValue ? _this.previousSearchValue : undefined);
                                }
                            },
                        },
                    },
                    {
                        className: "col-3",
                        type: "input",
                        key: "protocol",
                        templateOptions: {
                            readonly: false,
                            label: this.translateService.instant("properties.documents.fields.protocollo"),
                            placeholder: this.translateService.instant("properties.documents.fields.protocollo"),
                            required: false,
                            minLength: 0,
                            maxLength: 500,
                        },
                        expressionProperties: {
                            "templateOptions.onChange": function (model) {
                                _this.protocol = model.protocol && model.protocol !== "" ? model.protocol : "";
                                if (_this.previousProtocol !== _this.protocol) {
                                    _this.previousProtocol = _this.protocol;
                                    _this.docSearchChanged(_this.previousSearchValue ? _this.previousSearchValue : undefined);
                                }
                            },
                        },
                    },
                    {
                        className: "col-3",
                        type: "input",
                        key: "keyword",
                        templateOptions: {
                            readonly: false,
                            label: this.translateService.instant("properties.documents.fields.keyword"),
                            placeholder: this.translateService.instant("properties.documents.fields.keyword"),
                            required: false,
                            minLength: 0,
                            maxLength: 1000,
                            rows: 3
                        },
                        expressionProperties: {
                            "templateOptions.onChange": function (model) {
                                _this.keyword = model.keyword && model.keyword !== "" ? model.keyword : "";
                                if (_this.previousKeyword !== _this.keyword) {
                                    _this.previousKeyword = _this.keyword;
                                    _this.docSearchChanged(_this.previousSearchValue ? _this.previousSearchValue : undefined);
                                }
                            },
                        },
                    }
                ],
            },
        ];
        // this.documentArchiveIsLoading = false;
    };
    /**
     * Prepare formly fields
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.initValues = function (fieldConfig) {
        if (!fieldConfig) {
            this.toastrService.error(this.translateService.instant("common.errors.generic_error_message", "1"));
            return;
        }
        this.areasField = fieldConfig.fieldGroup.filter(function (field) {
            return field.key === "areas";
        })[0];
        this.argumentsField = fieldConfig.fieldGroup.filter(function (field) {
            return field.key === "arguments";
        })[0];
        this.categoriesField = fieldConfig.fieldGroup.filter(function (field) {
            return field.key === "categories";
        })[0];
    };
    /**
     * Get courrent property structure data and populate
     * this.condoStructure
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.getStructureData = function (structureId) {
        var _this = this;
        this.condoStructuresService.get(structureId).subscribe(function (res) {
            if (res.status) {
                _this.condoStructure = res.data;
                // If property has a document Archive ID, then retrieve related data
                if (_this.documentArchiveId) {
                    _this.getDocumentArchiveData();
                    _this.initForm();
                    // Stop loading dialog
                    setTimeout(function () {
                        _this.documentArchiveIsLoading = false;
                    }, 500);
                }
                else {
                    _this.documentArchiveIsLoading = false;
                    _this.toastrService.error(res.message);
                }
            }
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    /**
     * Get current property documentArchive data and populate
     * this.documentArchive
     * this.allDocs is used to show all docs in page
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.getDocumentArchiveData = function (reload) {
        var _this = this;
        if (reload === void 0) { reload = false; }
        this.documentArchiveIsLoading = true;
        this.insertedDocs = [];
        this.documentArchivesService
            .get(this.documentArchiveId)
            .subscribe(function (res) {
            if (res.status) {
                _this.documentArchive = res.data;
                if (_this.documentArchive.suppliersName) {
                    _this.suppliersName = _this.documentArchive.suppliersName;
                }
                if (_this.documentArchive.yearsOfStorage) {
                    _this.yearsOfStorage = _this.documentArchive.yearsOfStorage;
                }
                if (_this.documentArchive.conductorName) {
                    _this.conductorName = _this.documentArchive.conductorName;
                }
                if (_this.documentArchive.nameInterventionArchiving) {
                    _this.nameInterventionArchiving =
                        _this.documentArchive.nameInterventionArchiving;
                }
                if (_this.subscriptionType !== 'FREE' && _this.subscriptionType !== 'FREEBASIC') {
                    _this.allDocs = _this.documentTypeStructure.getDocumentArchiveData(_this.lang, _this.documentTemplate, _this.condoStructure, _this.documentArchive, _this.subscriptionType, _this.insertedDocs);
                }
                else {
                    _this.allDocs = _this.documentTypeStructure.getDocumentArchiveDataFree(_this.lang, _this.documentTemplate, _this.documentArchive, _this.subscriptionType, _this.insertedDocs);
                }
                if (reload) {
                    _this.docSearchChanged(_this.previousSearchValue ? _this.previousSearchValue : undefined);
                }
            }
            else {
                _this.toastrService.error(res.message);
            }
            _this.documentArchiveIsLoading = false;
        });
    };
    /**
     * Utility: extracts documents from one section of documentArchive
     * and show the documents into page
     * in getDocumentArchiveData()
     *
     * array of documents
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.getDocsFromSection = function (section) {
        var _this = this;
        var docList = [];
        var _loop_1 = function (doc) {
            if (section.documents[doc].length) {
                section.documents[doc].forEach(function (item) {
                    if (!item.deleted) {
                        if (item.data &&
                            item.data.nomeSocietaEroganteInServizio &&
                            // && (item.data.rilasciatoFirmatoDa 
                            //   || item.data.nomeDiRiferimento
                            //   || item.data.nomeSocietaEroganteInServizio)
                            typeof item.data.ragioneSocialeFornitore === "undefined") {
                            if (item.data.rilasciatoFirmatoDa) {
                                item.data["ragioneSocialeFornitore"] = item.data.rilasciatoFirmatoDa;
                            }
                            else if (item.data.nomeDiRiferimento) {
                                item.data["ragioneSocialeFornitore"] = item.data.nomeDiRiferimento;
                            }
                            else {
                                item.data["ragioneSocialeFornitore"] = item.data.nomeSocietaEroganteInServizio;
                            }
                        }
                        if (item.data && item.data.barCode) {
                            if (item.data.barCode.length > 6) {
                                item.data["docCode"] = item.data.barCode.substring(item.data.barCode.length - 7, item.data.barCode.length - 1);
                            }
                        }
                        docList.push({
                            title: _this.translateService.instant("properties.documents.titles." + doc),
                            type: "doc",
                            docId: item._id,
                            key: doc,
                            mandatory: (_this.subscriptionType === "FREE" || _this.subscriptionType === 'FREEBASIC') ? false : item.mandatory,
                            expired: item.expired,
                            deleted: item.deleted,
                            dateExpired: item.dateExpired,
                            contract: item.contract,
                            pdfmsg: item.pdfmsg,
                            data: item.data,
                            checked: false,
                        });
                    }
                    if (!item.deleted && item.data) {
                        _this.insertedDocs.push({
                            title: _this.translateService.instant("properties.documents.titles." + doc),
                            docId: item._id,
                            data: item.data,
                            checked: false,
                        });
                    }
                });
            }
        };
        for (var doc in section.documents) {
            _loop_1(doc);
        }
        docList.sort(this.compareExpired);
        return docList;
    };
    /**
     * Utility: extracts only contracts from one section of documentArchive
     * and show the documents into page
     * in getDocumentArchiveData()
     *
     * array of documents
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.getDocsFromContractSection = function (section, keyTranslateTitle) {
        var _this = this;
        var docList = [];
        var _loop_2 = function (doc) {
            if (section.documents[doc].length) {
                section.documents[doc].forEach(function (item) {
                    if (item.contract) {
                        if (!item.deleted) {
                            if (item.data &&
                                item.data.nomeSocietaEroganteInServizio &&
                                // (item.data.rilasciatoFirmatoDa ||
                                //   item.data.nomeDiRiferimento ||
                                //   item.data.nomeSocietaEroganteInServizio) &&
                                typeof item.data.ragioneSocialeFornitore === "undefined") {
                                if (item.data.rilasciatoFirmatoDa) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.rilasciatoFirmatoDa;
                                }
                                else if (item.data.nomeDiRiferimento) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.nomeDiRiferimento;
                                }
                                else {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.nomeSocietaEroganteInServizio;
                                }
                            }
                            if (item.data && item.data.barCode) {
                                if (item.data.barCode.length > 6) {
                                    item.data["docCode"] = item.data.barCode.substring(item.data.barCode.length - 7, item.data.barCode.length - 1);
                                }
                            }
                            docList.push({
                                title: _this.translateService.instant("properties.documents.titles." + doc),
                                type: "doc",
                                docId: item._id,
                                key: doc,
                                mandatory: (_this.subscriptionType === "FREE" || _this.subscriptionType === 'FREEBASIC') ? false : item.mandatory,
                                expired: item.expired,
                                deleted: item.deleted,
                                dateExpired: item.dateExpired,
                                contract: item.contract,
                                pdfmsg: item.pdfmsg,
                                data: item.data,
                                checked: false,
                                keyTranslateTitle: keyTranslateTitle,
                            });
                        }
                        // only contracts
                        var contractSection = doc.substr(0, 2) === "HA" ? true : false;
                        if (!item.deleted && item.data && contractSection) {
                            _this.insertedDocs.push({
                                title: _this.translateService.instant("properties.documents.titles." + doc),
                                docId: item._id,
                                data: item.data,
                                checked: false,
                                keyTranslateTitle: keyTranslateTitle,
                            });
                        }
                    }
                });
            }
        };
        for (var doc in section.documents) {
            _loop_2(doc);
        }
        docList.sort(this.compareExpired);
        return docList;
    };
    /**
     * Order docs by expired property
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.compareExpired = function (a, b) {
        if (a.expired < b.expired) {
            return -1;
        }
        else if (a.expired > b.expired) {
            return 1;
        }
        else {
            return 0;
        }
    };
    /**
     * Filter proper document arguments basing on form values
     *
     * @since 1.0.0
     */
    /**
     * Handle value changes
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.docSearchChanged = function (value) {
        var _this = this;
        var sinonimi = [
            {
                key: "bilancio",
                value: "rendiconto",
            },
            {
                key: "bilanci",
                value: "rendiconto",
            },
            {
                key: "consuntivo",
                value: "rendiconto",
            },
            {
                key: "consuntivi",
                value: "rendiconto",
            },
            {
                key: "dipendenti",
                value: "dipendente",
            },
            {
                key: "custode",
                value: "dipendente",
            },
            {
                key: "custodi",
                value: "dipendente",
            },
            {
                key: "portiere",
                value: "dipendente",
            },
            {
                key: "portieri",
                value: "dipendente",
            },
            {
                key: "portinaio",
                value: "dipendente",
            },
            {
                key: "portinai",
                value: "dipendente",
            },
            {
                key: "guardiola",
                value: "portineria",
            },
            {
                key: "guardiole",
                value: "portineria",
            },
            {
                key: "responsabile servizio prevenzione e protezione",
                value: "rspp",
            },
            {
                key: "responsabili servizio prevenzione e protezione",
                value: "rspp",
            },
            {
                key: "responsabili servizi prevenzione e protezione",
                value: "rspp",
            },
            {
                key: "sicurezza dipendente",
                value: "rspp",
            },
            {
                key: "sicurezza dipendenti",
                value: "rspp",
            },
            {
                key: "81/08",
                value: "rspp",
            },
            {
                key: "documento valutazione rischi",
                value: "dvr",
            },
            {
                key: "documento valutazioni rischi",
                value: "dvr",
            },
            {
                key: "documenti valutazione rischi",
                value: "dvr",
            },
            {
                key: "documenti valutazioni rischi",
                value: "dvr",
            },
            {
                key: "sicurezza condominio",
                value: "dvr",
            },
            {
                key: "sicurezza condomini",
                value: "dvr",
            },
            {
                key: "rischi",
                value: "dvr",
            },
            {
                key: "rischio",
                value: "dvr",
            },
            {
                key: "626",
                value: "dvr",
            },
            {
                key: "81/08",
                value: "dvr",
            },
            {
                key: "licenza di occupazione",
                value: "abitabilita'/agibilita'",
            },
            {
                key: "licenze di occupazione",
                value: "abitabilita'/agibilita'",
            },
            {
                key: "sanatoria",
                value: "condono",
            },
            {
                key: "sanatorie",
                value: "condono",
            },
            {
                key: "contatore luce",
                value: "contatore elettrico",
            },
            {
                key: "contatori luce",
                value: "contatore elettrico",
            },
            {
                key: "luci",
                value: "contatore elettrico",
            },
            {
                key: "luce",
                value: "contatore elettrico",
            },
            {
                key: "illuminazione",
                value: "contatore elettrico",
            },
            {
                key: "illuminazioni",
                value: "contatore elettrico",
            },
            {
                key: "fornitura energia elettrica",
                value: "contatore elettrico",
            },
            {
                key: "forniture energia elettrica",
                value: "contatore elettrico",
            },
            {
                key: "impianto di m.a.t.",
                value: "messa a terra",
            },
            {
                key: "impianti di m.a.t.",
                value: "messa a terra",
            },
            {
                key: "cabina di media, media tensione",
                value: "mt",
            },
            {
                key: "cabine di media, media tensione",
                value: "mt",
            },
            {
                key: "pannelli solari",
                value: "fotovoltaico",
            },
            {
                key: "pannello solare",
                value: "fotovoltaico",
            },
            {
                key: "latrici solari",
                value: "fotovoltaico",
            },
            {
                key: "latrice solare",
                value: "fotovoltaico",
            },
            {
                key: "generatore",
                value: "gruppo elettrogeno",
            },
            {
                key: "generatori",
                value: "gruppo elettrogeno",
            },
            {
                key: "alimentatore",
                value: "gruppo elettrogeno",
            },
            {
                key: "alimentatori",
                value: "gruppo elettrogeno",
            },
            {
                key: "parafulmine",
                value: "scariche atmosferiche",
            },
            {
                key: "parafulmini",
                value: "scariche atmosferiche",
            },
            {
                key: "protezione fulmini",
                value: "scariche atmosferiche",
            },
            {
                key: "protezione fulmine",
                value: "scariche atmosferiche",
            },
            {
                key: "protezioni fulmini",
                value: "scariche atmosferiche",
            },
            {
                key: "protezioni fulmine",
                value: "scariche atmosferiche",
            },
            {
                key: "caldaia",
                value: "centrale termica",
            },
            {
                key: "caldaie",
                value: "centrale termica",
            },
            {
                key: "riscaldamento",
                value: "centrale termica",
            },
            {
                key: "riscaldamenti",
                value: "centrale termica",
            },
            {
                key: "bruciatore",
                value: "centrale termica",
            },
            {
                key: "bruciatori",
                value: "centrale termica",
            },
            {
                key: "metano",
                value: "contatore gas",
            },
            {
                key: "rete gas",
                value: "contatore gas",
            },
            {
                key: "reti gas",
                value: "contatore gas",
            },
            {
                key: "camino",
                value: "canna fumaria",
            },
            {
                key: "camini",
                value: "canna fumaria",
            },
            {
                key: "climatizzazione",
                value: "condizionamento",
            },
            {
                key: "climatizzazioni",
                value: "condizionamento",
            },
            {
                key: "cdz",
                value: "condizionamento",
            },
            {
                key: "aria condizionata",
                value: "condizionamento",
            },
            {
                key: "impianto di raffreddamento",
                value: "condizionamento",
            },
            {
                key: "impianti di raffreddamento",
                value: "condizionamento",
            },
            {
                key: "impianto elevatore",
                value: "ascensore",
            },
            {
                key: "impianti elevatore",
                value: "ascensore",
            },
            {
                key: "autoclave",
                value: "centrale idrica",
            },
            {
                key: "pompe acqua",
                value: "impianto di sollevamento acque",
            },
            {
                key: "pompa acqua",
                value: "impianto di sollevamento acque",
            },
            {
                key: "videosorveglianza",
                value: "tvcc",
            },
            {
                key: "videosorveglianze",
                value: "tvcc",
            },
            {
                key: "telecamere",
                value: "tvcc",
            },
            {
                key: "telecamera",
                value: "tvcc",
            },
            {
                key: "passo carraio",
                value: "automazione cancelli",
            },
            {
                key: "passi carrai",
                value: "automazione cancelli",
            },
            {
                key: "cancello elettrico",
                value: "automazione cancelli",
            },
            {
                key: "cancelli elettrici",
                value: "automazione cancelli",
            },
            {
                key: "allarme",
                value: "antintrusione",
            },
            {
                key: "allarmi",
                value: "antintrusione",
            },
            {
                key: "antifurto",
                value: "antintrusione",
            },
            {
                key: "antifurti",
                value: "antintrusione",
            },
            {
                key: "scia",
                value: "prevenzione incendi",
            },
            {
                key: "cpi",
                value: "prevenzione incendi",
            },
            {
                key: "certificato prevenzione incendi",
                value: "prevenzione incendi",
            },
            {
                key: "certificati prevenzione incendi",
                value: "prevenzione incendi",
            },
            {
                key: "vigili del fuoco",
                value: "prevenzione incendi",
            },
            {
                key: "vigile del fuoco",
                value: "prevenzione incendi",
            },
            {
                key: "818/84",
                value: "prevenzione incendi",
            },
            {
                key: "manichette",
                value: "rete idranti",
            },
            {
                key: "manichetta",
                value: "rete idranti",
            },
            {
                key: "attestato certificazione energetica",
                value: "ace/ape",
            },
            {
                key: "attestati certificazione energetica",
                value: "ace/ape",
            },
            {
                key: "attestati certificazioni energetiche",
                value: "ace/ape",
            },
            {
                key: "ape",
                value: "ace/ape",
            },
            {
                key: "attestato di prestazione energetica",
                value: "ace/ape",
            },
            {
                key: "attestati di prestazioni energetiche",
                value: "ace/ape",
            },
            {
                key: "certificazione energetica",
                value: "ace/ape",
            },
            {
                key: "certificazioni energetiche",
                value: "ace/ape",
            },
            {
                key: "spurghi",
                value: "rete fognaria",
            },
            {
                key: "spurgo",
                value: "rete fognaria",
            },
            {
                key: "fogna",
                value: "rete fognaria",
            },
            {
                key: "fogne",
                value: "rete fognaria",
            },
            {
                key: "fognatura",
                value: "rete fognaria",
            },
            {
                key: "fognature",
                value: "rete fognaria",
            },
            {
                key: "disegni",
                value: "elaborati grafici",
            },
            {
                key: "disegno",
                value: "elaborati grafici",
            },
            {
                key: "tavola",
                value: "elaborati grafici",
            },
            {
                key: "tavole",
                value: "elaborati grafici",
            },
            {
                key: "planimetria",
                value: "elaborati grafici",
            },
            {
                key: "planimetrie",
                value: "elaborati grafici",
            },
            {
                key: "piantina",
                value: "elaborati grafici",
            },
            {
                key: "piantine",
                value: "elaborati grafici",
            },
        ];
        var index = sinonimi.findIndex(function (el) {
            return el.key && value && el.key.toLowerCase() === value.toLowerCase();
        });
        if (index > -1) {
            value = sinonimi[index].value;
        }
        if (value && value.length > 2) {
            this.searchIsLoading = true;
            var filteredData = [];
            // singolare e plurale
            var lastLetter = value.charAt(value.length - 1);
            var search = new RegExp(value, "igm");
            if (lastLetter === "a" ||
                lastLetter === "e" ||
                lastLetter === "i" ||
                lastLetter === "o" ||
                lastLetter === "u") {
                var val = value.substring(0, value.length - 1);
                var valuea = val + "a";
                var valuee = val + "e";
                var valuei = val + "i";
                var valueo = val + "o";
                var valueu = val + "u";
                value = valuea + "|" + valuee + "|" + valuei + "|" + valueo + "|" + valueu;
                search = new RegExp(value, "igm");
            }
            if (this.allDocs && Array.isArray(this.allDocs) && this.allDocs.length > 0) {
                var parentsTitles = [];
                filteredData = this.filterDisplayedDocs(parentsTitles, this.allDocs, search);
            }
            this.displayedDocs = filteredData;
            // Stop loading dialog
            setTimeout(function () {
                _this.searchIsLoading = false;
                if (_this.displayedDocs.length) {
                    _this.showEmailBtn = true;
                }
                else {
                    _this.showEmailBtn = false;
                }
            }, 500);
        }
        else {
            var filteredData = [];
            if (this.allDocs && Array.isArray(this.allDocs) && this.allDocs.length > 0) {
                var parentsTitles = [];
                filteredData = this.filterDisplayedDocs(parentsTitles, this.allDocs, undefined);
            }
            this.displayedDocs = filteredData;
            // Stop loading dialog
            setTimeout(function () {
                _this.searchIsLoading = false;
                if (_this.displayedDocs.length) {
                    _this.showEmailBtn = true;
                }
                else {
                    _this.showEmailBtn = false;
                }
            }, 500);
        }
    };
    /**
     * Search for documents that have not expired, have inserted files
     * and the linked structure is activated
     */
    SearchDocumentsComponent.prototype.filterDisplayedDocs = function (parentsTitles, docs, searchValue) {
        var _this = this;
        // Shared & Temporary users
        if (this.loggedUserShared || this.loggedUserTemporary) {
            switch (docs.keyTranslateTitle) {
                case "properties.documents.gestionaleAmministrativo":
                    if (!this.currentRole.propertiesPermission.gestionaleAmministrativo) {
                        return {};
                    }
                    break;
                case "properties.documents.verbaliconvocazioni":
                    if (!this.currentRole.propertiesPermission.gestionaleContabile) {
                        return {};
                    }
                    break;
                case "properties.documents.urbanisticaEdEdilizia":
                    if (!this.currentRole.propertiesPermission.urbanisticaEdEdilizia) {
                        return {};
                    }
                    break;
                case "properties.documents.catasto":
                    if (!this.currentRole.propertiesPermission.catasto) {
                        return {};
                    }
                    break;
                case "properties.documents.locazioneContrdiLocazione":
                    if (!this.currentRole.propertiesPermission.contratti) {
                        return {};
                    }
                    break;
                case "properties.documents.contratti":
                    if (!this.currentRole.propertiesPermission.contratti) {
                        return {};
                    }
                    break;
                case "properties.documents.lineaVita":
                    if (!this.currentRole.propertiesPermission.lineaVita) {
                        return {};
                    }
                    break;
                case "properties.documents.amiantoDoc":
                    if (!this.currentRole.propertiesPermission.amiantoDoc) {
                        return {};
                    }
                    break;
                case "properties.documents.edile":
                    if (!this.currentRole.propertiesPermission.edile) {
                        return {};
                    }
                    break;
                case "properties.documents.impiantoElettrico":
                    if (!this.currentRole.propertiesPermission.impiantoElettrico) {
                        return {};
                    }
                    break;
                case "properties.documents.riscaldamentoCondizionamento":
                    if (!this.currentRole.propertiesPermission.riscaldamentoCondizionamento) {
                        return {};
                    }
                    break;
                case "properties.documents.ascensoriEMontauto":
                    if (!this.currentRole.propertiesPermission.ascensori) {
                        return {};
                    }
                    break;
                case "properties.documents.trattamentoAcqua":
                    if (!this.currentRole.propertiesPermission.trattamentoAcqua) {
                        return {};
                    }
                    break;
                case "properties.documents.impiantiElettronici":
                    if (!this.currentRole.propertiesPermission.impiantiElettronici) {
                        return {};
                    }
                    break;
                case "properties.documents.attivitaSottopostePrevenzioneIncendi":
                    if (!this.currentRole.propertiesPermission.antincendio) {
                        return {};
                    }
                    break;
                case "properties.documents.impiantiAntincendio":
                    if (!this.currentRole.propertiesPermission.antincendio) {
                        return {};
                    }
                    break;
                case "properties.documents.impiantiSpeciali":
                    if (!this.currentRole.propertiesPermission.impiantiSpeciali) {
                        return {};
                    }
                    break;
                case "properties.documents.impiantiRicreativiSportivi":
                    if (!this.currentRole.propertiesPermission.impiantiRicreativiSportivi) {
                        return {};
                    }
                    break;
                case "properties.documents.R6manutenzioni":
                    if (!this.currentRole.propertiesPermission.preventivi) {
                        return {};
                    }
                    break;
                case "properties.documents.unitaImmobiliari":
                    if (!this.currentRole.propertiesPermission.unitaImmobiliari) {
                        return {};
                    }
                    break;
            }
        }
        if (docs.content && Array.isArray(docs.content) && docs.content.length) {
            var values = {};
            parentsTitles.push(docs.title);
            var contents = this.filterDisplayedDocs(parentsTitles, docs.content, searchValue);
            parentsTitles.pop();
            // only docs of active structures
            if (contents &&
                Array.isArray(contents) &&
                contents.length &&
                (typeof docs.active === "undefined" || docs.active)) {
                values = {
                    content: contents,
                    docId: docs.docId,
                    structureId: docs.structureId,
                    title: docs.title,
                    type: docs.type,
                    active: docs.active,
                    keyTranslateTitle: docs.keyTranslateTitle
                };
            }
            return values;
        }
        else {
            if (docs && Array.isArray(docs) && docs.length) {
                var content_1 = [];
                docs.forEach(function (docs) {
                    parentsTitles.push(docs.title);
                    var ret = _this.filterDisplayedDocs(parentsTitles, docs, searchValue);
                    // only docs of active structures
                    if (!(Object.keys(ret).length === 0 && ret.constructor === Object) &&
                        ret !== "") {
                        if (typeof ret.active === "undefined" || ret.active) {
                            content_1.push(ret);
                        }
                    }
                    parentsTitles.pop();
                });
                return content_1;
            }
            else {
                var found = false;
                if (docs.data) {
                    // only inserted docs and not expired
                    if (typeof searchValue === 'undefined' &&
                        this.supplierId === "" &&
                        this.protocol === "" &&
                        this.keyword === "" &&
                        this.dateFrom === "" &&
                        this.dateTo === "") {
                        found = false;
                    }
                    else {
                        found = true;
                    }
                    if (typeof searchValue !== 'undefined') {
                        if (parentsTitles.length && docs.title && typeof docs.data.contenutoDocumento !== "undefined") {
                            var index = parentsTitles.findIndex(function (el) {
                                return searchValue.test(el);
                            });
                            if (index === -1 && !searchValue.test(docs.title) && !searchValue.test(docs.data.contenutoDocumento)) {
                                found = false;
                            }
                        }
                        else if (parentsTitles.length === 0 && docs.title && typeof docs.data.contenutoDocumento !== "undefined") {
                            if (!searchValue.test(docs.title) && !searchValue.test(docs.data.contenutoDocumento)) {
                                found = false;
                            }
                        }
                        else if (parentsTitles.length && !docs.title && typeof docs.data.contenutoDocumento !== "undefined") {
                            var index = parentsTitles.findIndex(function (el) {
                                return searchValue.test(el);
                            });
                            if (index === -1 && !searchValue.test(docs.data.contenutoDocumento)) {
                                found = false;
                            }
                        }
                        else if (parentsTitles.length && docs.title && typeof docs.data.contenutoDocumento === "undefined") {
                            var index = parentsTitles.findIndex(function (el) {
                                return searchValue.test(el);
                            });
                            if (index === -1 && !searchValue.test(docs.title)) {
                                found = false;
                            }
                        }
                    }
                    if (this.supplierId !== "") {
                        if (!(typeof docs.data.ragioneSocialeFornitoreId !== 'undefined' &&
                            docs.data.ragioneSocialeFornitoreId !== null &&
                            docs.data.ragioneSocialeFornitoreId &&
                            docs.data.ragioneSocialeFornitoreId.toString() === this.supplierId.toString())) {
                            found = false;
                        }
                    }
                    if (this.protocol !== "") {
                        var protocol = new RegExp(this.protocol, "igm");
                        if (!protocol.test(docs.data.protocollo)) {
                            found = false;
                        }
                    }
                    if (this.keyword !== "") {
                        var keyword = new RegExp(this.keyword, "igm");
                        if (!keyword.test(docs.data.keyword)) {
                            found = false;
                        }
                    }
                    if (this.dateFrom !== "" && this.dateTo !== "") {
                        if (!(!docs.data.dataDocumentochkNA &&
                            moment(docs.data.dataDocumento).diff(this.dateFrom) >= 0 &&
                            moment(docs.data.dataDocumento).diff(this.dateTo) <= 0)) {
                            found = false;
                        }
                    }
                    else if (this.dateFrom !== "" && !this.dateTo) {
                        if (!(!docs.data.dataDocumentochkNA &&
                            moment(docs.data.dataDocumento).diff(this.dateFrom) >= 0)) {
                            found = false;
                        }
                    }
                    else if (!this.dateFrom && this.dateTo !== "") {
                        if (!(!docs.data.dataDocumentochkNA &&
                            moment(docs.data.dataDocumento).diff(this.dateTo) <= 0)) {
                            found = false;
                        }
                    }
                }
                else {
                    found = false;
                }
                if (found) {
                    return docs;
                }
            }
        }
        return "";
    };
    /**
     * Handle click on document and open dialog box to edit/show document data
     *
     * modalTitle: title of dialogbox from document name
     * documentKey: doc type, es. AA1, AA2, etc.
     * documentId: the ID of document into array of documentArchive section (es. gestAmmTivoDipendenti)
     * subDocumentId: the ID of sub document into array of docs type (es. AA1)
     * itemData: data value of form items
     * action: edit or show doc data
     * documentFather:
     * keyTranslateTitle:
     * structureId: related structure Id
     * expired:
     * contractPdfMsg:
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.onToggleEditShowDocument = function (modalTitle, documentKey, documentId, subDocumentId, itemData, action, documentFather, keyTranslateTitle, structureId, expired, contractPdfMsg, topic) {
        var _this = this;
        // if (this.subscriptionType === "FREE") {
        //   documentId = "undefined";
        // }
        // Create formly default fields
        var defaultFields = [
            {
                className: "col-12 col-md-12 col-xl-12",
                type: "textarea",
                key: "contenutoDocumento",
                templateOptions: {
                    label: this.translateService.instant("properties.detail.documentArchive.fields.contenutoDocumento"),
                    placeholder: this.translateService.instant("properties.detail.documentArchive.fields.contenutoDocumento"),
                    required: true,
                    minLength: 2,
                    maxLength: 500,
                    rows: 5,
                    disabled: action === "show" ? true : false,
                },
            },
            {
                className: "col-12 col-md-12 col-xl-12",
                type: "input",
                key: "protocollo",
                templateOptions: {
                    readonly: false,
                    label: this.translateService.instant("properties.detail.documentArchive.fields.protocollo"),
                    placeholder: this.translateService.instant("properties.detail.documentArchive.fields.protocollo"),
                    required: false,
                    minLength: 0,
                    maxLength: 500,
                },
            },
            {
                className: "col-12 col-md-12 col-xl-12",
                type: "textarea",
                key: "keyword",
                templateOptions: {
                    readonly: false,
                    label: this.translateService.instant("properties.detail.documentArchive.fields.keyword"),
                    placeholder: this.translateService.instant("properties.detail.documentArchive.fields.keyword"),
                    required: false,
                    minLength: 0,
                    maxLength: 1000,
                    rows: 3
                },
            }
        ];
        // create fields formly from document key: es AA1
        // const aryfields = this.documentTypeStructure.getFormlyFields(
        //   documentKey,
        //   false
        // );
        var schemaType = JSON.parse(JSON.stringify(this.documentTypeStructure.getDocumentType2(documentKey, this.documentTemplate)));
        var aryfields = this.documentTypeStructure.getFormlyFields2(schemaType, false);
        aryfields.forEach(function (item) {
            if (item.templateOptions && item.templateOptions.placeholder) {
                item.templateOptions.placeholder = _this.translateService.instant(item.templateOptions.placeholder);
            }
            if (item.type === "select") {
                if (Array.isArray(item.templateOptions.options)) {
                    item.templateOptions.options.forEach(function (subItem) {
                        subItem.label = _this.translateService.instant(subItem.label);
                    });
                }
            }
            if (item.type === "selectNew") {
                item.type = "autocomplete";
                if (item.templateOptions.initialValues) {
                    var options_1 = [];
                    switch (item.templateOptions.initialValues) {
                        case "suppliersName":
                            _this.suppliersName.forEach(function (subItem) {
                                // options.push({
                                //   value: subItem,
                                //   label: subItem,
                                // });
                                options_1.push(subItem);
                            });
                            break;
                        case "yearsOfStorage":
                            _this.yearsOfStorage.forEach(function (subItem) {
                                // options.push({
                                //   value: subItem,
                                //   label: subItem,
                                // });
                                options_1.push(subItem);
                            });
                            break;
                        case "conductorName":
                            _this.conductorName.forEach(function (subItem) {
                                // options.push({
                                //   value: subItem,
                                //   label: subItem,
                                // });
                                options_1.push(subItem);
                            });
                            break;
                        case "nameInterventionArchiving":
                            _this.nameInterventionArchiving.forEach(function (subItem) {
                                // options.push({
                                //   value: subItem,
                                //   label: subItem,
                                // });
                                options_1.push(subItem);
                            });
                            break;
                    }
                    item.templateOptions.initialValues = options_1;
                    item.templateOptions.addTagText = _this.translateService.instant(item.templateOptions.addTagText);
                    item.templateOptions.customLabel = _this.translateService.instant(item.templateOptions.customLabel);
                }
            }
            if (item.type === "autocomplete" ||
                item.type === "autocomplete-supplier") {
                item.templateOptions.addTagText = _this.translateService.instant(item.templateOptions.addTagText);
                item.templateOptions.customLabel = _this.translateService.instant(item.templateOptions.customLabel);
                if (item.templateOptions.search$ === "suppliersService") {
                    item.templateOptions.search$ =
                        _this.suppliersService.getListV2.bind(_this);
                }
            }
            else {
                if (item.templateOptions && item.templateOptions.label) {
                    item.templateOptions.label = _this.translateService.instant(item.templateOptions.label);
                }
            }
            if (action === "show" && item.templateOptions) {
                item.templateOptions.disabled = true;
            }
        });
        // const contract = this.documentTypeStructure.isContract(documentKey);
        var contract = this.documentTypeStructure.isContract2(documentKey, this.documentTemplate);
        var fieldGroup = aryfields.concat(defaultFields);
        var itemConfig = [
            {
                fieldGroupClassName: "row",
                fieldGroup: fieldGroup,
            },
        ];
        var propertyCode = this.propertyData.code;
        var companyCode = this.company.get("code");
        var barCode = "";
        if (itemData && itemData.barCode) {
            barCode = itemData.barCode;
        }
        // const selectedArea =
        //   this.documentTypeStructure.getAreaFromChild(keyTranslateTitle);
        var selectedArea = this.documentTypeStructure.getAreaFromChild2(keyTranslateTitle, this.documentTemplate);
        var title;
        if (keyTranslateTitle) {
            title = keyTranslateTitle.split("properties.documents.")[1];
        }
        var dialogRef = this.dialog.open(PropertyDetailDocumentItemDialogComponent, {
            data: {
                modalTitle: modalTitle,
                documentArchiveId: this.documentArchiveId,
                documentTypeRoute: this.documentTypeStructure.getDocRoute2(documentKey, this.documentTemplate),
                documentId: documentId,
                documentKey: documentKey,
                subDocumentId: subDocumentId,
                itemData: JSON.parse(JSON.stringify(itemData)),
                itemConfig: itemConfig,
                propertyCode: propertyCode,
                companyCode: companyCode,
                barCode: barCode,
                action: action,
                documentFather: documentFather,
                keyTranslateTitle: title,
                structureId: structureId !== '' ? structureId : undefined,
                contract: contract,
                expired: expired,
                contractPdfMsg: contractPdfMsg,
                selectedArea: selectedArea,
                property: this.propertyData,
                companyData: this.loggedUserMaster ? this.companyData : "",
                propertyName: this.propertyName,
            },
            width: "700px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                // return;
            }
            else {
                // recreate view of all docs to show new inserted doc
                _this.getDocumentArchiveData(true);
            }
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    /**
     * Update docs array with incoming element
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.onDocSelected = function (doc, checked) {
        if (doc && checked) {
            this.selectedDocs.push(doc.value.docId);
        }
        else if (doc && !checked) {
            var index = this.selectedDocs.indexOf(doc.value.docId);
            this.selectedDocs.splice(index, 1);
        }
    };
    /**
     * Send docs by email
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.onSendByEmail = function () {
        var _this = this;
        if (!this.selectedDocs.length) {
            this.toastrService.error(this.translateService.instant("common.errors.chooseElementFirst"));
            return;
        }
        // Open dialog
        var newMessageDialogRef = this.newMessageDialog.open(SendEmailDialogComponent, {
            minWidth: "60%",
            maxHeight: "98vh",
            data: {
                phonebook: this.company.get("phonebook")
                    ? this.company.get("phonebook")
                    : [],
                insertedDocs: this.insertedDocs,
                selectedDocs: this.selectedDocs,
                companyData: this.loggedUserMaster ? this.companyData : "",
                propertyName: this.propertyName,
                propertyId: this.propertyId,
                sentFromSupplierPage: false,
            },
            disableClose: true,
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        newMessageDialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            _this.toastrService.success(_this.translateService.instant("communications.add.sendedSuccessfully"));
        });
    };
    /**
     * Handle click on document form to download file
     * itemData: data value of form items
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.onToggleDownloadDocument = function (documents) {
        if (!documents || !documents.length) {
            console.warn("ERROR: NO DOCS");
            return;
        }
        var dialogRef = this.dialog.open(DocumentDownloadDialogComponent, {
            data: {
                propertyId: this.propertyId,
                documents: documents,
            },
            width: "600px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
        });
    };
    /**
     * Handle click on document form to print file
     * area: document area
     * topic: document topic
     * type: document type
     * modalTitle: title of dialogbox from document name
     * documentKey: doc type, es. AA1, AA2, etc.
     * documentId: the ID of document into array of documentArchive section (es. gestAmmTivoDipendenti)
     * subDocumentId: the ID of sub document into array of docs type (es. AA1)
     * itemData: data value of form items
     * action: edito or show doc data
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.onTogglePrintDocument = function (subArea, area, topic, structure, modalTitle, documentKey, documentId, subDocumentId, itemData) {
        var propertyCode = this.propertyData.code;
        var companyCode = this.company.get("code");
        // const areaNumber = this.documentTypeStructure.getAreaFromChild(subArea);
        var areaNumber = this.documentTypeStructure.getAreaFromChild2(subArea, this.documentTemplate);
        var selectedArea = this.documentTypeStructure.getDocumentArea2(areaNumber.toString(), this.documentTemplate);
        var barCode = "";
        if (itemData && itemData.barCode) {
            barCode = itemData.barCode;
        }
        var name = this.propertyData.name;
        var city = this.propertyData.address.city;
        var address = this.propertyData.address.route + " " + this.propertyData.address.streetNumber;
        this.dialog.open(PropertyDetailDocumentItemPrintDialogComponent, {
            data: {
                modalTitle: modalTitle,
                documentArchiveId: this.documentArchiveId,
                documentTypeRoute: this.documentTypeStructure.getDocRoute2(documentKey, this.documentTemplate),
                documentId: documentId,
                documentKey: documentKey,
                subDocumentId: subDocumentId,
                itemData: itemData,
                propertyCode: propertyCode,
                companyCode: companyCode,
                barCode: barCode,
                name: name,
                city: city,
                address: address,
                area: area,
                topic: topic,
                structure: structure,
                subArea: selectedArea && selectedArea.title ? selectedArea.title : '',
            },
            width: "600px",
        });
    };
    /**
     * Export properties in a file with given format
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.onExport = function (target, propertyId) {
        var _this = this;
        if (target && typeof propertyId !== "undefined") {
            // Handle export for missing/inserted documents
            var date = formatDate(new Date(), "yyyyMMddhhmmss", "en-EN");
            var fileName_1 = this.translateService.instant("properties.list." + target) + " " + date;
            this.subscriptions.push(this.propertiesService.getDocExport(target, propertyId).subscribe(function (res) {
                var fileBlob = res;
                var blob = new Blob([fileBlob], {
                    type: "application/vnd.ms-excel",
                });
                FileSaver.saveAs(blob, fileName_1 + ".xlsx");
            }, function (err) {
                _this.helperService.handleError(err);
            }));
        }
    };
    /**
     * Handle table sort
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.sortData = function (sort, i, t, x, pos) {
        var _this = this;
        var sortedData = [];
        if (pos === "1") {
            sortedData = this.displayedDocs[i].content[t].content[x].content;
        }
        else if (pos === "2") {
            sortedData = this.displayedDocs[i].content[t].content;
        }
        else if (pos === "3") {
            sortedData = this.displayedDocs[i].content;
        }
        var data = sortedData;
        if (!sort.active || sort.direction === "") {
            sortedData = data;
            if (pos === "1") {
                this.displayedDocs[i].content[t].content[x].content = sortedData;
            }
            else if (pos === "2") {
                this.displayedDocs[i].content[t].content = sortedData;
            }
            else if (pos === "3") {
                this.displayedDocs[i].content = sortedData;
            }
            return;
        }
        sortedData = data.sort(function (a, b) {
            var isAsc = sort.direction === "asc";
            switch (sort.active) {
                case "title":
                    return _this.compare(a.title.toLowerCase(), b.title.toLowerCase(), isAsc);
                case "data.contenutoDocumento":
                    var aContenutoDocumento = a.data && a.data.contenutoDocumento
                        ? a.data.contenutoDocumento.toLowerCase()
                        : "";
                    var bContenutoDocumento = b.data && b.data.contenutoDocumento
                        ? b.data.contenutoDocumento.toLowerCase()
                        : "";
                    return _this.compare(aContenutoDocumento, bContenutoDocumento, isAsc);
                case "data.ragioneSocialeFornitore":
                    var aRagioneSocialeFornitore = a.data && a.data.ragioneSocialeFornitore
                        ? a.data.ragioneSocialeFornitore
                        : "";
                    var bRagioneSocialeFornitore = b.data && b.data.ragioneSocialeFornitore
                        ? b.data.ragioneSocialeFornitore
                        : "";
                    return _this.compare(aRagioneSocialeFornitore, bRagioneSocialeFornitore, isAsc);
                case "data.dataDocumento":
                    var aDataDocumento = a.data && a.data.dataDocumento ? a.data.dataDocumento : "";
                    var bDataDocumento = b.data && b.data.dataDocumento ? b.data.dataDocumento : "";
                    return _this.compare(aDataDocumento, bDataDocumento, isAsc);
                case "dateExpired":
                    var aDateExpired = a.dateExpired ? a.dateExpired : "";
                    var bDateExpired = b.dateExpired ? b.dateExpired : "";
                    return _this.compare(aDateExpired, bDateExpired, isAsc);
                default:
                    return 0;
            }
        });
        if (pos === "1") {
            this.displayedDocs[i].content[t].content[x].content = sortedData;
        }
        else if (pos === "2") {
            this.displayedDocs[i].content[t].content = sortedData;
        }
        else if (pos === "3") {
            this.displayedDocs[i].content = sortedData;
        }
    };
    /**
     * Utility per table sort
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.compare = function (a, b, isAsc) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    };
    /**
     * Auto-select checkboxes of same sub-group
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.onAllSubDocsSelected = function (items, checked) {
        var _this = this;
        if (items && items.length) {
            items.forEach(function (item) {
                if (item.data && item.data.documentFile) {
                    item.checked = checked;
                    if (checked) {
                        _this.selectedDocs.push(item.docId);
                    }
                    else if (!checked) {
                        var index = _this.selectedDocs.indexOf(item.docId);
                        _this.selectedDocs.splice(index, 1);
                    }
                }
            });
        }
    };
    /**
     * Prevent redirect to archive if structure is open
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.onGoToDocumentArchive = function () {
        if (!this.mappaturaOpen) {
            return;
        }
        this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant('dialogs.confirm.mappaturaOpen.title'),
                message: this.translateService.instant('dialogs.confirm.mappaturaOpen.message'),
                btnCancelText: this.translateService.instant('common.cta.close'),
                messageOnly: true,
            },
            width: '500px',
            disableClose: false,
        });
    };
    /**
     * Show QRcode section
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.onTogglePrintSectionQRcode = function (item, docItem, subDocItem) {
        var name = this.propertyData.name;
        var city = this.propertyData.address.city;
        var address = this.propertyData.address.route + " " + this.propertyData.address.streetNumber;
        var structureId = "";
        if (subDocItem && subDocItem.structureId && subDocItem.structureId !== "") {
            structureId = subDocItem.structureId;
        }
        var selectedArea;
        if (item &&
            item.content &&
            Array.isArray(item.content) &&
            item.content.length) {
            if (item.content[0].keyTranslateTitle) {
                // const areaNumber = this.documentTypeStructure.getAreaFromChild(
                //   item.content[0].keyTranslateTitle
                // );
                var areaNumber = this.documentTypeStructure.getAreaFromChild2(item.content[0].keyTranslateTitle, this.documentTemplate);
                selectedArea = this.documentTypeStructure.getDocumentArea2(areaNumber.toString(), this.documentTemplate);
            }
        }
        var subStructureRoute = "";
        var subStructure = "";
        if (docItem) {
            subStructureRoute = docItem.keyTranslateTitle.replace("properties.documents.", "");
            subStructure = docItem.title;
        }
        var documentTypeRoute = item.keyTranslateTitle.replace("properties.documents.", "");
        this.dialog.open(PropertyDetailDocumentItemPrintDialogComponent, {
            data: {
                modalTitle: item.title,
                documentArchiveId: this.documentArchiveId,
                documentTypeRoute: documentTypeRoute,
                documentId: "",
                documentKey: "",
                subDocumentId: "",
                itemData: "",
                propertyCode: "",
                companyCode: "",
                barCode: "",
                name: name,
                city: city,
                address: address,
                area: "",
                topic: "",
                structure: "",
                subArea: selectedArea && selectedArea.title ? selectedArea.title : "",
                subStructureRoute: subStructureRoute,
                subStructure: subStructure,
                structureId: structureId,
            },
            width: "700px",
        });
    };
    /**
     * Word contracts export
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.onExportContracts = function () {
        var dialogRef = this.dialog.open(ExportContractsDialogComponent, {
            minWidth: "50%",
            maxHeight: "98vh",
            data: {
                propertyId: this.propertyId,
            },
            disableClose: true,
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            return;
        });
    };
    /**
     * RAS docs export in PDF format
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.onExportRAS = function () {
        var dialogRef = this.dialog.open(ExportRasDocsDialogComponent, {
            width: "700px",
            data: {
                propertyId: this.propertyId,
            },
            disableClose: true,
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            return;
        });
    };
    /**
     * Handle click on document form to delete file
     * itemData: data value of the document
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.onToggleDeleteDocument = function (item) {
        var _this = this;
        var dialogRef = this.dialog.open(PropertyDeleteDocumentItemDialogComponent, {
            data: {
                documentArchiveId: this.documentArchiveId,
                barCode: item.data.barCode ? item.data.barCode : '',
                mockup: item.mockup ? item.mockup : false,
                item: item,
            },
            width: "600px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            else {
                // recreate view of all docs to show new inserted doc
                _this.getDocumentArchiveData(true);
            }
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    /**
     * Handle click on document form to expire contract
     * itemData: data value of the document
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.onHandleExpiredContract = function (itemData) {
        var _this = this;
        var dialogRef = this.dialog.open(PropertyExpireContractItemDialogComponent, {
            data: {
                documentArchiveId: this.documentArchiveId,
                barCode: itemData.barCode ? itemData.barCode : '',
            },
            width: "600px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            else {
                // recreate view of all docs to show new inserted doc
                _this.getDocumentArchiveData(true);
            }
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    /**
     * Handle click on document form to delete file
     * modalTitle: title of dialogbox from document name
     * documentKey: doc type, es. AA1, AA2, etc.
     * documentId: the ID of document into array of documentArchive section (es. gestAmmTivoDipendenti)
     * subDocumentId: the ID of sub document into array of docs type (es. AA1)
     * itemData: data value of form items
     * action: edito or show doc data
     *
     * @since 1.0.0
     */
    SearchDocumentsComponent.prototype.onCancelContractDialogOpen = function (keyTranslateTitle, modalTitle, structureId, documentKey, documentId, subDocumentId, itemData) {
        var _this = this;
        var contract = tslib_1.__assign({}, itemData, { documentArchiveId: this.documentArchiveId, title: modalTitle, companyData: this.loggedUserMaster ? this.companyData : "", propertyName: this.propertyName, propertyId: this.propertyId });
        // Open dialog
        var dialogRef = this.cancelContractDialog.open(CancelContractDialogComponent, {
            minWidth: "60%",
            maxHeight: "98vh",
            data: {
                contract: contract,
                subject: this.translateService.instant("communications.fields.cancelContractSubject"),
                body: this.translateService.instant("communications.fields.cancelContractImmediateBody", { title: modalTitle.trim() }),
            },
            disableClose: true,
        });
        // On dialog closing, let's update model
        this.subscriptions.push(dialogRef.afterClosed().subscribe(function (res) {
            if (res) {
                var sendData = {
                    msg: res,
                };
                _this.subscriptions.push(_this.documentArchivesService
                    .cancelContract(_this.documentArchiveId, sendData)
                    .pipe(take(1))
                    .subscribe(function (res) {
                    if (!res) {
                        return;
                    }
                    else {
                        // recreate view of all docs to show new inserted doc
                        _this.getDocumentArchiveData(true);
                    }
                }, function (err) {
                    _this.helperService.handleError(err);
                }));
            }
            else {
                // console.warn("TASTO CHIUDI")
            }
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Handle reset all filters
     */
    SearchDocumentsComponent.prototype.onResetAll = function () {
        this.form.reset();
    };
    return SearchDocumentsComponent;
}());
export { SearchDocumentsComponent };
